module.exports = __webpack_public_path__ + "static/media/wall-centre-4.a69f5513.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/developer/gallery/wall-centre-4.jpg
// module id = 177
// module chunks = 0